import React from 'react';
import classNameBind from 'classnames/bind';
import Icon from '../../../Icon';
import styles from './Item.module.css';
import Tooltip from '../../../Tooltip';

const bindClasses = classNameBind.bind(styles);

const Item = ({
  dataId,
  fullWidth,
  icon,
  id,
  value,
  onChange,
  selected,
  text,
  tooltip,
}) => {
  const renderItem = () => (
    <label
      htmlFor={id}
      className={bindClasses('wrapper', { selected, 'full-width': fullWidth, narrow: !text })}
      data-ppuc-id={dataId}
    >
      <input
        type="checkbox"
        id={id}
        value={value}
        checked={selected}
        data-ppuc-id={`${dataId}.input`}
        onChange={onChange}
        tabIndex={0}
      />
      {icon && (
        <div data-ppuc-id={`${dataId}.icon`} className={bindClasses('icon', { 'icon-spaced': !!text })}>
          <Icon
            name={icon}
            color={selected ? 'white' : 'default'}
          />
        </div>
      )}
      {text && (
        <div className={bindClasses('text')} data-ppuc-id={`${dataId}.text`}>
          {text}
        </div>
      )}
    </label>
  );
  if (tooltip) {
    return (
      <Tooltip {...tooltip}>
        {renderItem()}
      </Tooltip>
    );
  }

  return renderItem();
};

Item.defaultProps = {
  fullWidth: false,
  icon: null,
  selected: false,
  text: '',
  tooltip: {},
};

export default Item;
